export function getLowestAmountAvailable(list, ...rest) {
  let lowest = Infinity;
  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  for (let i = 0; i < list.length; i++) {
    const value = rest.reduce((acc, key) => acc[key], list[i]);
    if (Number(value) < Number(lowest)) {
      lowest = value;
    }
  }

  return lowest;
}
